/*
 * Кастомный метод прослушивания touch событий
 *
 * чтобы вызвать:
 * swipeListener.init({
 *      element: '.our-block', // блок слушающий события
 *      maxDelta: 50, // расстояние в пикселях
 *      leftCallback: () => {},
 *      rightCallback: () => {}
 * })
 *
 */

var swipeListener = (function () {
    let touchstartX = 0;
    let touchendX = 0;

    let checkDirection = function (params) {
        let delta = Math.abs(touchstartX - touchendX);
        if (touchendX < touchstartX && delta >= params.maxDelta) {
            params.leftCallback();
        }
        if (touchendX > touchstartX && delta >= params.maxDelta) {
            params.rightCallback();
        }
    };

    let startEvent = (event) => {
        touchstartX = event.changedTouches[0].screenX;
    };

    let endEvent = (event, params) => {
        touchendX = event.changedTouches[0].screenX;
        checkDirection(params);
    };

    return {
        init(params) {
            if (document.querySelector(params.element)) {
                document
                    .querySelector(params.element)
                    .addEventListener('touchstart', (event) => {
                        startEvent(event, params);
                    });

                document
                    .querySelector(params.element)
                    .addEventListener('touchend', (event) => {
                        endEvent(event, params);
                    });
            }
        },
        destroy() {
            // to do метод удаления EventListener
        },
    };
})();

export { swipeListener };
